import Swal from 'sweetalert2'
import { useListView } from '../../core/ListViewProvider'
import { Button, TableSelectionBar } from '../../../../../../components'
import {
  downloadArquivo,
  IconPaths,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { downloadAvaliacao, downloadAvaliacaoLote } from '../../core/_requests'

export const AvaliacoesListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const count = selected.length

  const handleDownload = async () => {
    showAlertLoading()
    try {
      if (count > 1) {
        const arquivos = await downloadAvaliacaoLote(
          selected.map((item) => item.formularioAtendimentoId)
        )
        arquivos.forEach((arquivo) => downloadArquivo(arquivo))
      } else {
        const arquivo = await downloadAvaliacao(
          selected[0].atendimentoId,
          selected[0].formularioAtendimentoId
        )
        downloadArquivo(arquivo)
      }
      Swal.close()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <Button className='btn-primary' onClick={handleDownload} icon={IconPaths.Download}>
        {count === 1 ? 'Baixar avaliação' : 'Baixar avaliações'}
      </Button>
    </TableSelectionBar>
  )
}
